import { QuoteCommentsService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "../utils"
import { quoteActivityKey } from "./activity"

export const quoteCommentsBaseKey = ["quote-comments"] as const

export const quoteCommentsKey = (quoteId: string) =>
  [...quoteCommentsBaseKey, quoteId] as const

export const quoteCommentsQuery = makeQuery({
  serviceCall: QuoteCommentsService.listComments,
  queryKey: (params) => [...quoteCommentsKey(params.quote_id), params],
})

export const quoteTaskCommentCountsQuery = makeQuery({
  serviceCall: QuoteCommentsService.countByTask,
  queryKey: (params) => [...quoteCommentsKey(params.quote_id), "task-counts"],
})

export const useCreateQuoteCommentMutation = makeAxiosMutation({
  serviceCall: QuoteCommentsService.create,
  invalidates: (params) => [
    quoteCommentsKey(params.quote_id),
    quoteActivityKey(params.quote_id),
  ],
})
